import React from 'react';
import {getRootStore} from './_react_/app.bootstrap';
import {ScreenLoader} from './_react_/components/screen-loader/screen-loader';
import {observer, Provider} from 'mobx-react';
import {RouterProviderComponent} from './_react_/router/router.provider';

export const GlobalApplicationLoader: React.FC = observer(() => {
    const rootStore = getRootStore();
    const isLoading = rootStore.appState.showGlobalLoader;

    if (isLoading) {
        return (
            <>
                <div style={{position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, zIndex: 9999}}>
                    <ScreenLoader />
                </div>
            </>
        );
    }

    return <></>;
});

export const TechseeLiveApp: React.FC = () => {
    const rootStore = getRootStore();

    return (
        <>
            <React.StrictMode>
                <Provider rootStore={rootStore}>
                    <>
                        <GlobalApplicationLoader />
                        <RouterProviderComponent />
                    </>
                </Provider>
            </React.StrictMode>
        </>
    );
};
